import { measureLatency } from '../../gctl-measure';
import {
  UserCapabilitiesFields,
  UserCapabilities,
} from '../../models/components/schemas/user-capabilities/UserCapabilities';
import { Select, NetworkError, deepCamelCase, intoSnakeCase } from '../../fetchers/_helpers';

/**
 * This file was automatically generated by @gctl/openapi-fetchers
 * Do not modify this file, any changes will be destroyed when
 * the command is rerun.
 */

export type GetUserCapabilitiesFields = readonly UserCapabilitiesFields[];

/** Options for GET /users/{user_id}/capabilities */
export type GetUserCapabilitiesOptions<Paths extends readonly string[]> = Omit<
  RequestInit,
  'method' | 'body'
> & {
  baseUrl?: string;

  /** Available fields on the response type, application/vnd.vimeo.capabilities+json */
  select: Paths;
  where: {
    /**
     * The ID of the user.
     */
    userId: number;
  };
};

/** Result type for GET /users/{user_id}/capabilities */
export type GetUserCapabilitiesResult<Paths extends readonly string[]> = Select<
  UserCapabilities,
  Paths
>;

/**
 * Get user capabilities
 * This method returns the set of capabilities belonging to the specified user.
 */
export async function getUserCapabilities<Paths extends GetUserCapabilitiesFields>({
  baseUrl,
  select,
  where: { userId },
  ...options
}: GetUserCapabilitiesOptions<Paths>): Promise<GetUserCapabilitiesResult<Paths>> {
  return measureLatency('getUserCapabilities', 'GET', async () => {
    let res = await fetch(
      `${baseUrl}/users/${userId}/capabilities?fields=${select.map(intoSnakeCase).join(',')}`,
      {
        ...options,
        method: 'GET',
      },
    );

    if (!res.ok) {
      throw new NetworkError('A network error occurred', res.status, res);
    }

    if (res.status === 204) {
      return null as unknown as GetUserCapabilitiesResult<Paths>;
    }

    if (!res.headers.get('content-type')?.match(/^application\/(.+)?json$/)) {
      throw new Error('Expected JSON response');
    }

    let json = await res.json();
    return deepCamelCase(json);
  });
}
